import Options from '../../Options.esm.js';

var sequenceMatcher = (() => {
  return {
    warning: Options.translations.warnings.sequences,
    suggestions: [Options.translations.suggestions.sequences]
  };
});

export { sequenceMatcher as default };
//# sourceMappingURL=feedback.esm.js.map
